import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../config/firebase';
import { getRaceDistanceResults, getTotalCompetitionResults, listKUTCEditions, KUTCEdition } from './kutcResultsService';
import { buildMilestoneRecords, MilestoneCheckpoint } from '../utils/kutcMilestoneRecords';

export async function getMilestoneRecords(knownEditions?: KUTCEdition[]) {
  const editions = knownEditions || await listKUTCEditions();
  const data = await Promise.all(editions.filter(e => e.metadata?.resultsStatus !== 'error').map(async edition => {
    const [total, checkpoints, races] = await Promise.all([
      getTotalCompetitionResults(edition.id),
      getDocs(query(collection(db, 'checkpointResults'), where('eventEditionId', '==', edition.id))),
      Promise.all((edition.metadata?.races || []).filter(r => /^\d+-loops$/.test(r.distanceKey)).map(async race => ({
        loops: Number(race.distanceKey.split('-')[0]), name: race.raceName,
        results: await getRaceDistanceResults(edition.id, race.distanceKey)
      })))
    ]);
    return { id: edition.id, year: edition.year, total, races,
      checkpoints: checkpoints.docs.map(d => d.data() as MilestoneCheckpoint) };
  }));
  return buildMilestoneRecords(data);
}
